// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Reducer$LiteracyplanetTupperware from "../Reducer.res.mjs";
import * as ContextMaker$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/ContextMaker.res.mjs";
import * as V2ExerciseContext$LiteracyplanetTupperware from "../v2/V2ExerciseContext.res.mjs";
import * as V2ExerciseStateStoreContext$LiteracyplanetTupperware from "../v2/V2ExerciseStateStoreContext.res.mjs";

var Sig = {
  name: "MultiChoiceApi"
};

var MultiChoiceApi = ContextMaker$LiteracyplanetClientFlags.Make(Sig);

function V3MultiChoiceOptionContext(props) {
  var responseOptionId = props.responseOptionId;
  var questionIndex = props.questionIndex;
  var match = V2ExerciseStateStoreContext$LiteracyplanetTupperware.useDispatch();
  var dispatch = match[1];
  var match$1 = V2ExerciseContext$LiteracyplanetTupperware.use();
  var responseType = Reducer$LiteracyplanetTupperware.buildResponseType(props.group, responseOptionId);
  var marked = Reducer$LiteracyplanetTupperware.getMarkType(Curry._1(match$1.getStep, questionIndex), responseOptionId);
  var selected = Curry._2(match$1.isResponseSelected, questionIndex, responseOptionId);
  var onClickOption = function (param) {
    Curry._1(dispatch, {
          TAG: "SetQuestionState",
          _0: questionIndex,
          _1: responseType,
          _2: "ResponseMarking"
        });
  };
  return React.createElement(MultiChoiceApi.Provider.make, {
              value: {
                onClickOption: onClickOption,
                selected: selected,
                marked: marked
              },
              children: props.children
            });
}

var use = MultiChoiceApi.use;

var make = V3MultiChoiceOptionContext;

export {
  Sig ,
  MultiChoiceApi ,
  use ,
  make ,
}
/* MultiChoiceApi Not a pure module */
